import { convertUnitPriceToFormattedPrice } from 'utils/shared/money/convertUnitPriceToFormattedPrice';
import { pluralize } from 'utils/shared/pluralize';
import AddPhoto from 'svg/AddPhoto';
import Pencil from 'svg/Pencil';
import Button from 'components/Button';
import EnablePrompt from 'components/Premium/EnablePrompt';
import classNames from 'styles/utils/classNames';
import SubscriptionStatusLoading from './SubscriptionStatusLoading';
import { ConfigurePremiumProps } from './props';

const ConfigurePremium: React.FC<ConfigurePremiumProps> = ({
  handleEdit,
  handleUpload,
  className,
  standalone = true,
  loading,
  isSubscriptionDisabled,
  price,
  subscribers,
  currency,
}) => {
  if (loading) return <SubscriptionStatusLoading className={className} />;

  return isSubscriptionDisabled ? (
    <EnablePrompt onSubscribe={handleEdit} className={className} standalone={standalone} />
  ) : (
    <div className={classNames('flex flex-col', standalone && 'gap-6', className)}>
      <div
        className={classNames(
          'p-ds-xl',
          standalone &&
            'rounded-[24px] border border-color-border-input-lightmode shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode',
        )}
      >
        <div className="typography-product-heading-compact-desktop flex justify-between gap-2 text-color-brand-primary">
          <h4 className="whitespace-nowrap">Content Subscription</h4>
          <span>{convertUnitPriceToFormattedPrice(price, currency).priceDisplay}/month</span>
        </div>
        <hr className="my-ds-lg" />
        <div className="flex items-end gap-2">
          <span className="typography-product-heading-compact-desktop">{subscribers}</span>
          <span className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            {pluralize({
              singular: 'Subscriber',
              plural: 'Subscribers',
              count: subscribers,
              hideCount: true,
            })}
          </span>
        </div>
      </div>
      <div className={classNames('flex gap-2', !standalone && 'px-ds-xl pb-ds-xl')}>
        <Button
          variant="secondary"
          iconLeft={<Pencil className="h-5 w-5" />}
          size="lg"
          className="whitespace-nowrap"
          onClick={handleEdit}
        >
          Edit Info
        </Button>
        <Button
          variant="brand"
          iconLeft={<AddPhoto className="h-5 w-5" />}
          size="lg"
          className="whitespace-nowrap"
          onClick={handleUpload}
        >
          Upload Video
        </Button>
      </div>
    </div>
  );
};

export default ConfigurePremium;
